<template>

  <v-dialog persistent :fullscreen="fullscreen" max-width="450" class="dialog-confirm" v-model="isCustomDialogOpen">
    <!-- (activator button) -->
    <template v-slot:activator="{ on, attrs }">
      <!-- Plain button style -->
      <v-btn v-bind="attrs" v-on="on" v-if="buttonStyle === 'plain'"
        plain
        :class="buttonClass"
        :height="buttonHeight"
        :width="buttonWidth"
        :color="buttonColor"
        :disabled="disabled">
        <span v-if="buttonText">{{ buttonText }}</span>
        <v-icon class="ml-2" :color="iconColor" v-if="icon">
          {{ icon }}
        </v-icon>
      </v-btn>

      <!-- Icon button style -->
      <v-btn v-bind="attrs" v-on="on" v-else-if="buttonStyle === 'icon'"
        icon
        :class="buttonClass"
        :height="buttonHeight"
        :width="buttonWidth"
        :color="buttonColor"
        :disabled="disabled">
        <v-icon :color="iconColor" v-if="icon">
          {{ icon }}
        </v-icon>
      </v-btn>

      <!-- Standard button style -->
      <v-btn v-bind="attrs" v-on="on" v-else
        :class="buttonClass"
        :height="buttonHeight"
        :width="buttonWidth"
        :outlined="buttonOutlined"
        :color="buttonColor"
        :disabled="disabled">
        <span v-if="buttonText">{{ buttonText }}</span>
        <v-icon class="ml-2" :color="iconColor" v-if="icon">
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>

    <!-- (dialog content) -->
    <v-card max-width="450px">
      <!-- Title -->
      <v-card-title class="text-h5">
        {{ title }}
      </v-card-title>

      <v-card-text style="font-size:1.25rem !important;text-align:center;line-height:32px;" class="px-5 mt-5 dialog-text">
        {{ message }}
      </v-card-text>

      <!-- Actions -->
      <v-card-actions class="mt-2">
        <v-btn
            large
            text
            color="grey lighten-1"
            class="px-5"
            @click="cancel">
          {{ cancelButtonText }}
        </v-btn>
        <v-spacer />
        <v-btn
            large
            :color="confirmButtonColor"
            class="mb-2 px-5"
            @click="confirm">
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {
  name: 'DialogConfirmButton',

  props: {
    message: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    confirmButtonText: {
      type: String,
      default: 'Confirm',
      required: false
    },
    confirmButtonColor: {
      type: String,
      default: 'primary',
      required: false
    },
    buttonClass: {
      type: String,
      required: false
    },
    buttonWidth: {
      type: [Number, String],
      required: false,
      default: null
    },
    buttonHeight: {
      type: [Number, String],
      required: false,
      default: null
    },
    buttonStyle: {
      type: String,
      default: null,
      required: false
    },
    buttonText: {
      type: String,
      default: null,
      required: false
    },
    buttonOutlined: {
      type: Boolean,
      default: false
    },
    buttonColor: {
      type: String,
      required: false
    },
    title: {
      type: String,
      default: '',
      required: false
    },
    fullscreen: {
      type: Boolean,
      default: false,
      required: false
    },
    icon: {
      type: String,
      required: false // default: 'mdi-open-in-new',
    },
    iconColor: {
      type: String,
      required: false,
      default: 'primary'
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel',
      required: false
    }
  },

  data () {
    return {
      isCustomDialogOpen: false
    }
  },

  methods: {
    confirm () {
      this.isCustomDialogOpen = false
      this.$emit('confirmed')
    },

    cancel () {
      this.isCustomDialogOpen = false
      this.$emit('canceled')
    }
  }
}
</script>

<style scoped>
  .v-card {
    border: 1px solid #525252 !important;
  }

  .dialog-text {
    font-size: 18px !important;
  }
</style>
